module.exports = new __parcel__URL__("GT-Pantheon_animation-fig-3-sac-002.82340a29.json").toString();